import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

const PlanCtx = createContext(null);

const EMPTY = {
  plan: "starter",
  plan_name: "Starter",
  plan_label: "Starter",
  organization_id: null,
  organization_name: null,
  capabilities: {},
  limits: { monthly_denial_cap: null, monthly_appeal_cap: null, user_seat_cap: null },
  usage: { year_month: "", denials_uploaded: 0, appeals_generated: 0, denials_pct: null, appeals_pct: null },
};

export function PlanProvider({ children }) {
  const { user } = useAuth();
  const [plan, setPlan] = useState(EMPTY);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) { setPlan(EMPTY); setLoaded(true); return; }
    try {
      const { data } = await api.get("/me/plan");
      setPlan(data);
    } catch {
      setPlan(EMPTY);
    } finally {
      setLoaded(true);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const can = useCallback((feature) => Boolean(plan?.capabilities?.[feature]), [plan]);

  return (
    <PlanCtx.Provider value={{ ...plan, loaded, can, refresh }}>{children}</PlanCtx.Provider>
  );
}

export const usePlan = () => useContext(PlanCtx) || { ...EMPTY, loaded: false, can: () => true, refresh: () => {} };
